import React from 'react';

export const hiddenTableHeaderLabel = (labelText: string): JSX.Element => (
  <span style={{ width: 1, height: 1, position: 'absolute', left: '-9999px' }}>
    {labelText}
  </span>
);
